
const contents = "mutation DismissPromptClients($promptKey: String!) {\n  dismissPrompt(input: {promptKey: $promptKey}) {\n    prompt {\n      isDismissed\n      promptKey\n    }\n  }\n}\n";
const sha256Hash = "5976081714269a5dd2dd8b1d9c18fb38956222729beb0aeb740161a78dbbb3e1";
export default { contents: contents, sha256Hash: sha256Hash };
